import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AllGames from "../pages/games/page";
import NewGames from "../pages/new-games/page";
import GameDetail from "../pages/game-detail/page";
import About from "../pages/about/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Terms from "../pages/terms/page";
import Disclaimer from "../pages/disclaimer/page";
import ResponsibleGaming from "../pages/responsible-gaming/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/games",
    element: <AllGames />,
  },
  {
    path: "/new-games",
    element: <NewGames />,
  },
  {
    path: "/games/:slug",
    element: <GameDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "/responsible-gaming",
    element: <ResponsibleGaming />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;